export default "__VITE_ASSET__Dof2PsCM__"